<template>
  <div class="findDealer" id="findDealer">
    <my-header />

    <div class="findMain clear">
      <div class="findLeft left">
        <p class="p1">联系</p>
        <p class="p2">
          <router-link to="/findDealer">寻找经销商</router-link>
        </p>
        <p class="p2">
          <router-link to="/contact">联系方式</router-link>
        </p>
      </div>
      <div class="findRight left">
        <div class="pre">
          <div class="allTitle">
            <span>寻找经销商</span>
          </div>
        </div>

        <div class="pre">
          <div class="content">
            <p class="contentTime">
              您也可以直接致电
              <span><strong>0750-6107993</strong></span>
              与我们联系。我们的工作时间为星期一至星期六上午8点至下午6点。
            </p>

            <div class="contentChoice">
              <el-form
                class="importsntLabel"
                :label-position="labelPosition"
                label-width="80px"
                :model="formLabelAlign"
              >
                <el-form-item>
                  <label>名</label>
                  <br />
                  <el-input v-model="formLabelAlign.name"></el-input>
                </el-form-item>
                <el-form-item>
                  <label>姓</label>
                  <br />
                  <el-input v-model="formLabelAlign.region"></el-input>
                </el-form-item>
                <el-form-item
                  prop="email"
                  :rules="[
                    {
                      required: false,
                      message: '请输入邮箱地址',
                      trigger: 'blur'
                    },
                    {
                      type: 'email',
                      message: '请输入正确的邮箱地址',
                      trigger: ['blur', 'change']
                    }
                  ]"
                >
                  <label>邮箱</label>
                  <br />
                  <el-input v-model="formLabelAlign.email"></el-input>
                </el-form-item>
                <el-form-item class="contentSelect">
                  <label>地区</label>
                  <br />
                  <el-cascader
                    size="large"
                    :options="options"
                    v-model="selectedOptions"
                    @change="handleChange"
                  >
                  </el-cascader>
                </el-form-item>
                <div class="choiceItem">
                  <p>是您的项目：</p>
                  <div>
                    <el-radio v-model="radio" label="住宅">住宅</el-radio>
                  </div>
                  <div>
                    <el-radio v-model="radio" label="会所">会所</el-radio>
                  </div>
                  <div>
                    <el-radio v-model="radio" label="酒店">酒店</el-radio>
                  </div>
                </div>

                <div class="choiceProduct">
                  <p class="productTitle">选择你感兴趣的产品：</p>
                  <p class="productWord">
                    选中所有适用的框。我们将尽最大努力将您定向到显示您希望看到的物品的经销商。
                  </p>
                  <el-checkbox-group v-model="checkList">
                    <div>
                      <el-checkbox label="智能锁"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="机械锁"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="柜拉门"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="门拉手"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="小五金"></el-checkbox>
                    </div>
                    <div>
                      <el-checkbox label="铜品装饰"></el-checkbox>
                    </div>
                    <div style="margin-top: 20px;">
                      <el-checkbox label="紧跟最新的产品新闻"></el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <el-form-item>
                  <el-button @click="submitForm()">发送</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 寻找经销商 -->

    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";
import Uilt from "@/uilt/uilt.js";
import { regionData, CodeToText } from "element-china-area-data";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      labelPosition: "top",
      formLabelAlign: {
        name: "",
        region: "",
        email: ""
      },
      value: "",
      options: regionData,
      radio: "",
      checkList: ["紧跟最新的产品新闻"],
      selectedOptions: "",
      selectText: ""
    };
  },

  mounted() {
    if (this.$route.query.go) {
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }
  },

  methods: {
    submitForm() {
      let that = this;
      if (!that.formLabelAlign.name) {
        that.$message({
          message: "请输入名",
          type: "error"
        });
        return;
      }
      if (!that.formLabelAlign.region) {
        that.$message({
          message: "请输入姓",
          type: "error"
        });
        return;
      }
      if (!that.formLabelAlign.email) {
        that.$message({
          message: "请输入邮箱",
          type: "error"
        });
        return;
      }
      if (!Uilt.validateMail(that.formLabelAlign.email)) {
        that.$message({
          message: "邮箱格式有误",
          type: "error"
        });
        return;
      }
      let product = that.checkList;
      let strProduct = "";
      if (product.length > 0) {
        for (let i = 0; i < product.length; i++) {
          strProduct += product[i] + ",";
        }
      }
      if (strProduct != "") {
        strProduct = strProduct.substring(0, strProduct.length - 1);
      }
      that.$axios
        .post(
          that.$global.baseURL + "/web/distributor/sendEmail.form",
          that.$qs.stringify({
            name: that.formLabelAlign.name,
            surname: that.formLabelAlign.region,
            email: that.formLabelAlign.email,
            cityName: that.selectText,
            project: that.radio,
            product: strProduct
          })
        )
        .then(res => {
          if (res.data.jsonArray == "error") {
            that.$message({
              message: res.data.errorInfo,
              type: "error"
            });
          } else {
            that.$message({
              message: "成功",
              type: "success"
            });
          }
        });
    },
    handleChange() {
      var loc = "";
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]];
      }
      this.selectText = loc;
    }
  }
};
</script>

<style>
/*最外层 */
.pre {
  width: 90%;
}

.findDealer .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  letter-spacing: 10px;
  font-weight: lighter;
  font-family: "microsoft yahei";
  padding-top: 50px;
  padding-bottom: 20px;
}

.findMain .findLeft {
  width: 100px;
  margin-left: 80px;
  margin-top: 65px;
  letter-spacing: 2px;
}

.findMain .findLeft .p1 {
  font-size: 18px;
  margin-bottom: 30px;
}

.findMain .findLeft .p2 {
  font-size: 14px;
}

.findMain .findLeft p {
  margin-top: -10px;
  color: #595757;
}

.findMain .findLeft a {
  text-decoration: none;
  color: #595757;
}

.findMain .findLeft a:hover {
  text-decoration: none;
  color: #ccb356;
}

.findMain .findRight {
  width: -moz-calc(100% - 180px);
  width: -webkit-calc(100% - 180px);
  width: calc(100% - 180px);
}

.content {
  width: 76%;
  margin: 0 auto;
  letter-spacing: 1px;
  margin-bottom: 150px;
}

.content .contentTime {
  font-size: 15px;
  color: #595757;
  margin-top: 20px;
  margin-bottom: 45px;
}

.contentChoice {
  margin-top: 20px;
}

.contentChoice .el-input {
  width: 320px;
}

.contentChoice .el-input__inner {
  margin-top: 0px;
}

.contentChoice .el-form-item__content {
  line-height: 15px;
}

.contentChoice .contentSelect .el-select {
  width: 160px;
}

.contentChoice .contentSelect .el-select .el-input {
  width: 160px;
}

.contentChoice .choiceItem p {
  font-size: 20px;
  font-weight: bold;
  margin-top: 50px;
  color: #595757;
}

.contentChoice .choiceProduct .productTitle {
  font-size: 20px;
  font-weight: bold;
  margin-top: 30px;
  color: #595757;
}

.contentChoice .choiceProduct .productWord {
  color: #595757;
  line-height: 14px;
}

/* 	.contentChoice .choiceProduct  .el-checkbox__input{
		line-height: 1;
	}
 */
.contentChoice .el-button {
  margin-top: 10px;
}

.importsntLabel label:after {
  content: "*";
  color: red;
}

.choiceItem label:after {
  content: " ";
}

.choiceProduct label:after {
  content: " ";
}

.el-cascader-menu {
  min-width: 114px;
}

.el-cascader-menu:first-child {
  min-width: 110px;
}

.el-cascader-menu:last-child {
  min-width: 110px;
}

/* 媒体查询 */
@media screen and (max-width: 850px) {
  .findMain .findLeft {
    /* width: 180px;
			height: 0;
			overflow-y: hidden; */
    display: none;
  }

  .findMain .findRight {
    width: 100%;
  }

  .findRight .pre {
    width: 100%;
  }

  .findRight .allTitle {
    width: 90%;
    margin-left: 30px;
    text-align: center;
    margin: 0 auto;
  }

  .content {
    width: 90%;
    margin: 0 auto;
    margin-left: 26px;
  }

  .content .contentTime {
    font-size: 15px;
    color: #595757;
    margin-top: 20px;
  }

  .contentChoice {
    width: 75%;
    margin: 0 auto;
  }

  .contentChoice .choiceProduct .productWord {
    line-height: 30px;
  }

  .contentChoice .el-input {
    width: 95%;
  }
}
</style>
